import { Action } from 'redux';
import { ErrorWrapper } from 'store/base';

export const REDUCER_NAME__ZONES = 'zones';

export interface ZoneListReduxState {
  type?: string;
  loading: boolean;
  errorWrapper?: ErrorWrapper;
}

const defaultState: ZoneListReduxState = {
  loading: false,
};

export default (
  state: ZoneListReduxState = defaultState,
  action: Action,
): ZoneListReduxState => {
  return state;
};
